export { PresetColors } from './presetColors';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/theme/interface/index.js
// module id = 1109
// module chunks = 0